export enum Sizes {
  XS = "extraSmall",
  S = "small",
  M = "medium",
  L = "large",
  XL = "extraLarge",
  XXL = "extraExtraLarge",
}
